import React, { PureComponent } from 'react';
import './BasketSofashield.scss';
import { getRange } from 'helpers';

interface OwnProps {
    sofashieldQuantity: number;
    linkedSku: string;
    optionsQuantity: number;
    range: string;
    loading: boolean;
    onChangeQuantity?: (linkedSku: string, sofashieldQuantity: number) => void;
    onRemove?: (linkedSku: string) => void;
}

const SOFASHIELD_URL = 'https://images.sofology.co.uk/image/upload/Sofashield/Sofashield_plus-logo_1.png';

export class BasketSofashield extends PureComponent<OwnProps> {
    handleRemoveClick = (): void => {
        this.props.onRemove && this.props.onRemove(this.props.linkedSku);
    };

    handleChangeQuantity = (linkedSku: string) => (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.props.onChangeQuantity && this.props.onChangeQuantity(linkedSku, parseInt(e.target.value));
    };

    render(): JSX.Element {
        const { loading } = this.props;

        return (
            <div className='sofashield-wrapper'>
                {this.renderContent()}
                {loading && <div className='sofashield-wrapper__overlay'></div>}
            </div>
        );
    }

    renderContent(): JSX.Element {
        const { optionsQuantity, range, onRemove } = this.props;
        const shouldShowRemoveButton = onRemove !== undefined;

        return (
            <>
                <div className='sofashield-wrapper__image'>
                    <img src={SOFASHIELD_URL} alt='Sofashield Logo' />
                </div>
                <div className='sofashield-wrapper__description'>Sofashield Plus for <span
                    className='sofashield-wrapper__description__range'>{range}</span></div>
                <div className='sofashield-wrapper__adjust'>
                    {optionsQuantity > 1 && this.renderSelect()}

                    {shouldShowRemoveButton && <a href='#' onClick={this.handleRemoveClick} className='sofashield-wrapper__adjust__remove'>Remove</a>}
                </div>
            </>
        );
    }

    renderSelect(): JSX.Element {
        const { optionsQuantity, loading, linkedSku, sofashieldQuantity, onChangeQuantity } = this.props;
        const optionsRange = getRange(optionsQuantity);
        const shouldDisableSelect = onChangeQuantity === undefined;

        return (
            <div className='sofashield-wrapper__adjust__options'>
                <select
                    onChange={this.handleChangeQuantity(linkedSku)}
                    value={loading ? optionsQuantity.toString() : sofashieldQuantity.toString()}
                    disabled={shouldDisableSelect}
                    className={shouldDisableSelect ? 'disabled' : ''}
                    aria-label='Sofashield quantity'
                >
                    {optionsRange.map((option: number) => <option value={option} key={option}>{option}</option>)}
                </select>
            </div>
        );
    }
}